import React from 'react'
import { Button, Box } from '@mui/material'
import { LogField } from '../../components/LogField'
import { GetApp } from '@mui/icons-material'
import { useDataProvider } from 'react-admin'

export default function RunExpand({
    record,
    query,
    disableLogPolling = false,
}) {
    const dataProvider = useDataProvider()

    const downloader = () => {
        dataProvider
            .GET_ONE_LOG('runs', { id: record.id })
            .then((res) => {
                //unless we use a library this is general advice for downloading data from api call
                //https://stackoverflow.com/questions/44656610/download-a-string-as-txt-file-in-react
                const element = document.createElement('a')
                element.setAttribute(
                    'href',
                    'data:text/plain;charset=utf-8,' +
                        encodeURIComponent(res.data)
                )
                element.download = `${record.name}.txt`
                document.body.appendChild(element) // Required for this to work in FireFox
                element.click()
            })
            .catch((err) => console.error(err))
    }

    return (
        <Box
            sx={{
                margin: '10px',
                '& > div': {
                    boxShadow: 'none',
                },
            }}
        >
            <LogField
                record={record}
                query={query}
                disableLogPolling={disableLogPolling}
            />
            <Box
                sx={{
                    margin: '20px 0 0',
                    display: 'flex',
                    width: '100%',
                    padding: '0 !important',
                    justifyContent: 'flex-end',
                }}
            >
                <Button
                    startIcon={<GetApp />}
                    variant={'outlined'}
                    label={'DOWNLOAD'}
                    sx={{
                        padding: '10px',
                        marginLeft: '10px',
                        fontSize: '1rem',
                    }}
                    color="primary"
                    onClick={downloader}
                >
                    {' '}
                    DOWNLOAD
                </Button>
            </Box>
        </Box>
    )
}
